<template>
  <div class="flex bg-white justify-center p-2" v-if="show_stats">
    <div class="flex" v-if="stats_loaded">
      <div class="px-4 text-lg text-right flex-none flex flex-row items-center" v-if="vault.key_document">
        <i class="fa fa-key text-brand mr-1"></i>
        <span class="text-grey-darker">{{ stats.key_documents.total }}</span>
      </div>
      <div class="px-4 text-lg text-right flex-none flex flex-row items-center" v-else>
        <i class="fa fa-tags text-brand mr-1"></i>
        <span class="text-grey-darker">{{ stats.for_file_tag.total }}</span>
      </div>
      <div class="px-4 text-lg text-right flex-none flex flex-row items-center">
        <i class="fa fa-comment text-brand mr-1"></i>
        <span class="text-grey-darker">{{ stats.discussions.total }}</span>
      </div>
      <div class="px-4 text-lg text-right flex-none flex flex-row items-center">
        <i class="fa fa-check-circle text-brand mr-1"></i>
        <span class="text-grey-darker">{{ stats.tasks.total }}</span>
      </div>
      <div class="px-4 text-lg text-right flex-none flex flex-row items-center">
        <i class="fa fa-calendar-check text-brand mr-1"></i>
        <span class="text-grey-darker">{{ stats.events.total }}</span>
      </div>
    </div>

    <div v-else class="text-xs text-grey-dark">
      <i class="fa fa-spin fa-circle-notch"></i> fetching stats
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["vault-id", "vaultStats", "vault"],

  data() {
    return {
      stats_loaded: false,
      show_stats: false,

      stats: {
        for_file_tag: {
          loaded: false,
          total: 0,
        },
        discussions: {
          loaded: false,
          total: 0,
        },
        tasks: {
          loaded: false,
          total: 0,
        },
        events: {
          loaded: false,
          total: 0,
        },
        key_documents: {
          loaded: false,
          total: 0,
        },
      },

      cancel_token: "",
    };
  },

  mounted() {
    const {
      id,
      user_role,
      files_count,
      discussions_count,
      events_count,
      tasks_count,
      key_documents_count
    } = this.vaultStats;

    let role = "";

    if (user_role) {
      role = _.camelCase(user_role.replace(id + "-", ""));
    }

    if (_.includes(["userE", "userF", "userG"], role)) {
      this.$emit("show-stats", false);
      this.show_stats = false;
    } else {
      this.$emit("show-stats", true);
      this.show_stats = true;

      this.stats.for_file_tag.total = files_count;
      this.stats.for_file_tag.loaded = true;

      this.stats.discussions.total = discussions_count;
      this.stats.discussions.loaded = true;

      this.stats.tasks.total = tasks_count;
      this.stats.tasks.loaded = true;

      this.stats.events.total = events_count;
      this.stats.events.loaded = true;

      this.stats.key_documents.total = key_documents_count;
      this.stats.key_documents.loaded = true;

      this.checkStatsLoaded();

      this.initListeners();
    }
  },

  methods: {
    checkVaultUserRole() {
      return axios
        .get(`/api/vaults/${this.vaultId}/my-role`, {
          cancelToken: this.cancel_token.token,
        })
        .then(({ data }) => {
          if (data) {
            let vault_id = this.vaultId;
            let role_name = data.name;
            let replace_char = vault_id + "-";

            let role = _.camelCase(role_name.replace(replace_char, ""));

            return role;
          }
        });
    },

    initListeners() {
      this.$ebus.$on("refresh-vaults", (payload) => {
        if (payload && payload.vaultId == this.vaultId) {
          this.getForFileAndTag();
        }
      });

      window.Echo.private(`App.User.${this.user.id}`).notification(
        (notification) => {
          if (
            notification.type == "App\\Notifications\\File\\UploadedToCloud" &&
            notification.vault.id == this.vaultId
          ) {
            this.getForFileAndTag();
            this.$ebus.$emit("update-unfiled");
          }

          if (
            notification.type ==
              "App\\Notifications\\Vault\\Discussion\\NewMessage" &&
            notification.conversation.vault_id == this.vaultId
          ) {
            this.getDiscussions();
          }
        }
      );
    },

    getVaultStats() {
      axios
        .get(
          `/api/vaults/${this.vaultId}/stats`,
          {
            params: {
              events_from_start_at: moment()
                .add(1, "days")
                .format("YYYY-MM-DD HH:mm:ss"),
            },
          },
          {
            cancelToken: this.cancel_token.token,
          }
        )
        .then(({ data }) => {
          // set each stats
          this.stats.for_file_tag.total = data.file_for_tag;
          this.stats.for_file_tag.loaded = true;

          this.stats.discussions.total = data.discussion;
          this.stats.discussions.loaded = true;

          this.stats.tasks.total = data.task;
          this.stats.tasks.loaded = true;

          this.stats.events.total = data.event;
          this.stats.events.loaded = true;

          this.checkStatsLoaded();
        });
    },

    getForFileAndTag() {
      // CURRENT DEFAULT = YOU
      axios
        .get(
          `/api/vaults/${this.vaultId}/files/for-tagging`,
          {
            params: {
              mine_only: 1,
            },
          },
          {
            cancelToken: this.cancel_token.token,
          }
        )
        .then(({ data }) => {
          this.stats.for_file_tag.total = data.total;
          this.stats.for_file_tag.loaded = true;
          this.checkStatsLoaded();
        });
    },

    getDiscussions() {
      // CURRENT DEFAULT = YOU
      axios
        .get(
          `/api/vaults/${this.vaultId}/discussions/mine`,
          {
            params: { items_per_page: 1 },
          },
          {
            cancelToken: this.cancel_token.token,
          }
        )
        .then(({ data }) => {
          this.stats.discussions.total = data.total;
          this.stats.discussions.loaded = true;
        })
        .then(() => {
          this.checkStatsLoaded();
        });
    },

    getTasks() {
      // CURRENT DEFAULT = YOU
      axios
        .get(
          `api/vaults/${this.vaultId}/tasks`,
          {
            params: {
              type: "pending",
            },
          },
          {
            cancelToken: this.cancel_token.token,
          }
        )
        .then(({ data }) => {
          this.stats.tasks.total = data.length;
          this.stats.tasks.loaded = true;
          this.checkStatsLoaded();
        });
    },

    getEvents() {
      // CURRENT DEFAULT = ALL
      axios
        .get(
          `api/vaults/${this.vaultId}/events`,
          {
            params: {
              own_only: 0,
              from_start_at: moment().day("-1").format("YYYY-MM-DD HH:mm:ss"),
            },
          },
          {
            cancelToken: this.cancel_token.token,
          }
        )
        .then(({ data }) => {
          this.stats.events.total = data.total;
          this.stats.events.loaded = true;
          this.checkStatsLoaded();
        });
    },

    checkStatsLoaded() {
      let loaded_stat = _.find(this.stats, (stat) => {
        return stat.loaded == true;
      });

      if (loaded_stat) {
        this.stats_loaded = true;
      }
    },
  },

  computed: {
    ...mapGetters({
      user: "getUser",
    }),
  },
};
</script>

<style>
</style>
